import styled, { keyframes } from 'styled-components';
import { CTAColors } from '../../styles/colors/colors.js';
import { getColorWithOpacity } from '../../utils/color.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinningSvg = styled.svg.withConfig({
  displayName: "Spinner__SpinningSvg",
  componentId: "sc-1atlezz-0"
})(["&&{animation:", " 2s linear infinite;}"], spin);
var dashEffect = keyframes(["0%{stroke-dasharray:3 289;stroke-dashoffset:0;}50%{stroke-dasharray:200 289;stroke-dashoffset:-90;}100%{stroke-dasharray:190 289;stroke-dashoffset:-286;}"]);
var RingFront = styled.circle.withConfig({
  displayName: "Spinner__RingFront",
  componentId: "sc-1atlezz-1"
})(["&&{animation:", " 1.5s ease-in-out infinite;fill:none;stroke-dasharray:289;stroke-dashoffset:-26;stroke-linecap:round;stroke-width:8px;stroke:", ";}"], dashEffect, CTAColors.primaryVariant);
var RingBack = styled.circle.withConfig({
  displayName: "Spinner__RingBack",
  componentId: "sc-1atlezz-2"
})(["&&{fill:none;stroke-width:8px;stroke:", ";}"], getColorWithOpacity(CTAColors.primaryVariant, 0.2));
function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return /*#__PURE__*/jsxs(SpinningSvg, {
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx(RingBack, {
      cx: "50",
      cy: "50",
      r: "46"
    }), /*#__PURE__*/jsx(RingFront, {
      cx: "50",
      cy: "50",
      r: "46"
    })]
  });
}
Spinner.displayName = "Spinner";

export { Spinner };
